import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "ri:apple-fill" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M11.6734 7.72161C10.7974 7.72161 9.44138 6.72561 8.01338 6.76161C6.12938 6.78561 4.40138 7.85361 3.42938 9.54561C1.47338 12.9416 2.92538 17.9576 4.83338 20.7176C5.76938 22.0616 6.87338 23.5736 8.33738 23.5256C9.74138 23.4656 10.2694 22.6136 11.9734 22.6136C13.6654 22.6136 14.1454 23.5256 15.6334 23.4896C17.1454 23.4656 18.1054 22.1216 19.0294 20.7656C20.0974 19.2056 20.5414 17.6936 20.5654 17.6096C20.5294 17.5976 17.6254 16.4816 17.5894 13.1216C17.5654 10.3136 19.8814 8.96961 19.9894 8.90961C18.6694 6.97761 16.6414 6.76161 15.9334 6.71361C14.0854 6.56961 12.5374 7.72161 11.6734 7.72161ZM14.7934 4.88961C15.5734 3.95361 16.0894 2.64561 15.9454 1.34961C14.8294 1.39761 13.4854 2.09361 12.6814 3.02961C11.9614 3.85761 11.3374 5.18961 11.5054 6.46161C12.7414 6.55761 14.0134 5.82561 14.7934 4.88961Z",
        fill: "black"
      })
    ], -1)
  ]))]))
}
export default { render: render }